<template>
  <v-container fluid class="gl-journal-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab :href="`#tab-journal`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Journal
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-items`" >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab-item :value="'tab-journal'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                <v-col cols="12" md="12">
                  <p class="text-h5">General Journal</p>
                </v-col>
              </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-select
                        class="mb-4"
                        :items="journaltype"
                        v-model="edit_journal.journaltype"
                        v-on:change="onChangeGLJournal($event, 'journaltype')"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the journal type"
                      >
                      </v-select>
                      <v-text-field
                        :readonly="isNotEditable"
                        class="mb-4"
                        v-model="edit_journal.journalname"
                        v-on:change="
                          onChangeGLJournal($event, 'journalname')
                        "
                        outlined
                        dense
                        placeholder="Journal Name"
                        persistent-hint
                        single-line
                        hint="Enter the journal name"
                      >
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-menu
                        :readonly="isNotEditable"
                        ref="menu_journaldate"
                        v-model="menu_journaldate"
                        :close-on-content-click="false"
                        :return-value.sync="journaldate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :readonly="isNotEditable"
                            outlined
                            dense
                            v-model="journaldate"
                            label="Journal Date"
                            v-bind="attrs"
                            v-bind:value="journaldate"
                            v-on:change="
                              onChangeGLJournal($event, 'journaldate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the journal date"
                            persistent-hint
                          >
                          </v-text-field
                          >
                        </template>
                        <v-date-picker
                          :readonly="isNotEditable"
                          v-model="journaldate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_journaldate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangeGLJournal(
                                journaldate,
                                'journaldate'
                              );
                              $refs.menu_journaldate.save(journaldate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <div style="padding-bottom: 15px;"></div>
                      <v-select
                        :readonly="true"
                        class="mb-4"
                        :items="glledgers.map(x => {return {text: x.ledgername, value: x._id};})"
                        v-model="edit_journal.ledgerid"
                        v-on:change="onChangeGLJournal($event, 'ledgerid')"
                        outlined
                        dense
                        placeholder="Ledger"
                        persistent-hint
                        single-line hint="Please choose the ledger">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-row>
                        <v-col>
                          <v-select
                          readonly
                            class="mb-4"
                            :items="['USD', 'SGD', 'KHR', 'THB']"
                            v-bind:value="ledger.primaryCurrency"
                            v-on:change="onChangeGLJournal($event, 'primaryCurrency');"
                            v-bind:error="errorindex == 5"
                            outlined
                            dense
                            placeholder="Currency 1"
                            persistent-hint
                            single-line
                            hint="Primary currency"
                          >
                          </v-select>
                        </v-col>
                        <v-col>
                          <v-select
                            readonly
                            class="mb-4"
                            :items="['USD', 'SGD', 'KHR', 'THB']"
                            v-bind:value="ledger.secondaryCurrency"
                            v-on:change="onChangeGLJournal($event, 'secondaryCurrency');"
                            outlined
                            dense
                            placeholder="Currency 2"
                            persistent-hint
                            single-line
                            hint="Secondary currency"
                          >
                          </v-select>
                        </v-col>
                      </v-row>
                      <v-text-field
                        :readonly="isNotEditable"
                        type="number"
                        class="mb-4"
                        v-bind:value="edit_journal.currencyRate"
                        v-bind:error="errorindex == 13"
                        v-on:change="onChangeGLJournal($event, 'currencyRate')"
                        outlined
                        dense
                        placeholder="Rate"
                        persistent-hint
                        single-line hint="Enter the currency rate">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>

                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/gl-journal/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="updateGLJournal()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col md="8">
                    <p class="text-h5">Items</p>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="6" md="4" align="right">
                    <v-btn
                      v-show="isEditable"
                      class="button-shadow mr-1"
                      color="success"
                      @click="isAddTransaction=true; new_transaction={}">
                      Add
                    </v-btn>
                    <v-btn
                      class="button-shadow mr-1"
                        to="/gl-journal/list"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                  </v-col>
                  </v-row>
                  <v-data-table
                        :headers="header_transaction"
                        sort-by="transrank"
                        :items="transactions"
                        :items-per-page="100"
                        :footer-props="footer"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteTransaction" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_transaction.transdesc }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteTransaction = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTransaction(delete_transaction)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemimage="{ item }">
                          <v-img
                            v-bind:lazy-src="item.itemimage"
                            min-width="50"
                            max-width="100"
                            v-bind:src="item.itemimage"
                          ></v-img>
                        </template>
                        <template v-slot:item.accountid="{ item }">
                          {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                        </template>
                        <template v-slot:item.transdate="{ item }">
                          {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="editTransactionDialog(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="deleteTransactionDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:body.append>
                            <tr>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>{{sum_credit}}</td>
                              <td>{{sum_debit}}</td>
                              <td><div v-html="balance_text"></div></td>
                            </tr>
                          </template>
                      </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_classes
                    v-model="accountclass"
                    outlined
                    dense
                    placeholder="Class"
                    persistent-hint
                    single-line hint="Please choose the class">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses
                    v-model="accountsubclass"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass).map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="new_transaction.accountid"
                    v-bind:error="errorindex == 11"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="new_transaction.transdesc"
                    v-bind:error="errorindex == 12"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.creditAmount"
                    v-bind:error="errorindex == 13"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Credit"
                    persistent-hint
                    single-line hint="Credit Amount">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.debitAmount"
                    v-bind:error="errorindex == 14"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Debit"
                    persistent-hint
                    single-line hint="Debit Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="insertTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_classes
                    v-model="accountclass2"
                    outlined
                    dense
                    placeholder="Class"
                    persistent-hint
                    single-line hint="Please choose the class">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses2
                    v-model="accountsubclass2"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass2).map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="edit_transaction.accountid"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_transaction.transdesc"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.creditAmount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Credit"
                    persistent-hint
                    single-line hint="Credit Amount">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.debitAmount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Debit"
                    persistent-hint
                    single-line hint="Debit Amount">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.currencyRate"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Currency Rate"
                    persistent-hint
                    single-line hint="Currency Rate">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.creditAmount2"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Credit 2"
                    persistent-hint
                    single-line hint="Credit Amount">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.debitAmount2"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Debit 2"
                    persistent-hint
                    single-line hint="Debit Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';
import { formatCurrency } from '@/util/tools';
import router from "@/Routes";

export default {
  data() {
    return {
      header_transaction: [
        { text: 'Date', value: 'transdate', width: '8%'},
        { text: 'Account', value: 'accountid', width: '30%'},
        { text: 'Description', value: 'transdesc'},
        { text: 'Credit', value: 'creditAmount', width: '10%'},
        { text: 'Debit', value: 'debitAmount', width: '10%'},
        { text: "Actions", value: "actions", sortable: false, width: '10%' },
      ],
      initvalue: {},
      change_journal: {},
      edit_journal: {},
      edit_transaction: {},
      new_transaction: {},
      delete_transaction: {},
      transactions: [],
      journaltype: ["General Journal"],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      menu_transdate: false,
      menu_transdate_edit: false,
      accountclass: null,
      accountclass2: null,
      accountsubclass: null,
      accountsubclass2: null,
      journaldate: null,
      journalduedate: null,
      menu_journaldate: false,
      menu_journalduedate: false,
      ledger: null,
      isEditTransaction: false,
      isAddTransaction: false,
      isDeleteTransaction: false,    
      errorindex: undefined,
      formatCurrency: formatCurrency,
    };
  },
  computed: {
    ...mapState("Account", ["accounts"]),
    ...mapState("GLJournal", ["isReceiving"]),
    ...mapState("GLLedger", ["glledgers"]),
    ...mapState("Department", ["departments"]),
    ...mapState("Location", ["locations"]),  
    ...mapState("SalesChannel", ["saleschannels"]),
    data_classes(){
      let object = Object.groupBy(this.accounts, item => {
        return item.accountclass;
      });
      let result = Object.keys(object);
      return result;
    },
    data_subclasses(){
      let filter = this.accounts.filter(account=>account.accountclass==this.accountclass);
      let object = Object.groupBy(filter, item => {
        return item.accountsubclass;
      });
      let result = Object.keys(object);
      return result;
    },
    data_subclasses2(){
      let filter = this.accounts.filter(account=>account.accountclass==this.accountclass2);
      let object = Object.groupBy(filter, item => {
        return item.accountsubclass;
      });
      let result = Object.keys(object);
      return result;
    },
    sum_credit(){
      let result = this.transactions.reduce((a, b) => a + parseFloat(b.creditAmount), 0);
      return isNaN(result) ? 0 : this.formatCurrency(result);
    },
    sum_debit(){
      let result = this.transactions.reduce((a, b) => a + parseFloat(b.debitAmount), 0);
      return isNaN(result) ? 0 : this.formatCurrency(result);
    },
    balance_text(){
      let result;
      if(this.sum_debit !== this.sum_credit) result = '<p style="color: red; margin-top: 15px; font-weight: bold; font-size: 9pt;">Not In Balance</p>';
      else result = '<p>&nbsp;</p>';
      return result;
    },
    isNotEditable(){
      let result = ['New'].indexOf(this.initvalue.journalstatus) == -1;
      return result;
    },
    isEditable(){
      let result = ['New'].indexOf(this.initvalue.journalstatus) >= 0;
      console.log(result);
      return result;
    }
  },
  methods: {
    ...mapActions("Account", ["getAccountsRequest"]),
    ...mapActions("GLJournal", ["deleteGLTransactionRequest", "getGLJournalsRequest", "insertGLTransactionRequest", "updateGLJournalRequest", "updateGLTransaction"]),
    ...mapActions("GLLedger", ["getGLLedgersRequest"]),
    ...mapActions("Department", ["getDepartmentsRequest"]),
    ...mapActions("Location", ["getLocationsRequest"]),
    ...mapActions("SalesChannel", ["getSalesChannelsRequest"]),
    checkError() {
      if (!this.accessname) {
        this.errorindex = 0;
        return false;
      }
      if (!this.accesspath) {
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkTransaction(){
      if(!this.new_transaction.accountid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.new_transaction.transdesc){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      if(this.new_transaction.creditAmount==null && this.new_transaction.debitAmount==null){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      if(this.new_transaction.creditAmount==null || this.new_transaction.creditAmount==''){
        this.new_transaction.creditAmount = 0;
      }
      if(this.new_transaction.debitAmount==null || this.new_transaction.debitAmount==''){
        this.new_transaction.debitAmount = 0;
      }
      this.errorindex = -1;
      return true;
    },
    clearTransaction() {
      this.edit_transaction = {};
      this.new_transaction = {};
    },
    deleteTransactionDialog(item) {
      this.isDeleteTransaction = true;
      this.delete_transaction = {_id: item._id, transdesc: item.transdesc};
    },
    async deleteTransaction(payload) {
      this.isDeleteTransaction = false;
      let response = await this.deleteGLTransactionRequest(payload);
      let index = this.transactions.findIndex((trans) => trans._id == response._id);
      this.transactions.splice(index, 1);
      this.getGLJournalsRequest();
    },
    async insertTransaction() {
      if(!this.checkTransaction()) return;
      let payload = Object.assign({journalid: this.initvalue._id}, this.new_transaction);
      let response = await this.insertGLTransactionRequest(payload);
      this.transactions.push(response);
      this.getGLJournalsRequest();
      this.clearTransaction();
      this.isAddTransaction = false;
    },
    editTransactionDialog(item) {
      let account = this.accounts.find(account=>account._id == item.accountid);
      this.accountclass2 = account.accountclass;
      this.accountsubclass2 = account.accountsubclass;
      this.edit_transaction = Object.assign({}, item);
      this.edit_transaction.transdate = formatStdDate(this.edit_transaction.transdate);
      this.isEditTransaction = true;
    },
    onChangeGLJournal(value, field) {
      this.change_journal[field] = value;
    },
    async updateGLJournal() {
      this.change_journal._id = this.initvalue._id;
      await this.updateGLJournalRequest(this.change_journal);
      router.push("/gl-journal/list");
    },
    async updateTransaction() {
      this.isEditTransaction = false;
      let response = await this.updateGLTransaction(this.edit_transaction);
      let index = this.transactions.findIndex((x) => x._id == response._id);
      this.transactions.splice(index, 1, response);
      this.clearTransaction();
      this.getGLJournalsRequest();
    },
  },
  async created() {
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.push({ name: "GLJournalList" });
    this.ledger = this.glledgers.find(ledger=>ledger._id==this.initvalue.ledgerid);
    this.edit_journal = Object.assign({}, this.initvalue);
    this.journaldate = formatStdDate(this.initvalue.journaldate);
    this.journalduedate = formatStdDate(this.initvalue.journalduedate);
    if (this.accounts.length==0) await this.getAccountsRequest();
    if (this.departments.length==0) await this.getDepartmentsRequest();
    if (this.glledgers.length==0) await this.getGLLedgersRequest();
    if (this.locations.length==0) await this.getLocationsRequest();
    if (this.saleschannels.length==0) await this.getSalesChannelsRequest();
    
    this.files = this.initvalue.files;
    this.transactions = Object.assign([], this.initvalue.transactions);
    
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
